import { ApiResourcify } from 'components/sharpr/api/ApiResourcify';
import _ from 'lodash';
import { AssetManager } from '../../../../sharpr/assetManager/AssetManager.js';

export function EmailDistListAddUserRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.loggedin.EmailDistListAddUser', {
		url: '/admin/distlist/:id/contacts/add',
		controllerAs: 'vm',
		controller: EmailDistListAddUserCtrl,
		templateUrl: '/ng/hub/Email/DistList/AddUser/EmailDistListAddUserCtrl.html?' + window.BUILD,
		permission: ['manage_groups'],
		resolve: {
			$title: () => 'Add User to Distribution List',
			style: () => AssetManager.css('/ng/hub/Email/DistList/AddUser/EmailDistListAddUserCtrl.css'),
		},
	});
}

export class EmailDistListAddUserCtrl {
	constructor($stateParams, $timeout, modal, Api, Identity) {
		'ngInject';
		// save injections
		this.id = $stateParams.id;
		this.$timeout = $timeout;
		this.modal = modal;
		this.Api = Api;
		this.Identity = Identity;
		// create an empty new user
		this.newUser = {};
		this.newUsers = [];
		this.focusFname();
	}

	isNewUserValid() {
		return this.newUser && this.newUser.fname && this.newUser.lname && /^[^@]+@[^@]+\.[^@]{2,}$/.test(this.newUser.email);
	}

	add() {
		if (!this.isNewUserValid()) {
			return;
		}
		const newUser = this.newUser;
		this.Api.create('/contacts', {
			fname: this.newUser.fname,
			lname: this.newUser.lname,
			fname_preferred: this.newUser.fname_preferred || null,
			lname_preferred: this.newUser.lname_preferred || null,
			email: this.newUser.email,
			created_by: this.Identity.user().id,
			mode: 'contact',
			role: 'observer',
			is_active: true,
		}).then(newId => {
			// TODO: handle error case
			this.Api.post(`/distribution_lists/${this.id}/contacts`, {
				user_id: newId,
			}).then(() => {
				newUser.checkmark = true;
			});
			newUser.id = newId;
		});
		this.newUsers.unshift(newUser);
		this.newUsers = this.newUsers.slice(0, 10);
		this.newUser = {};
		this.focusFname();
	}

	editUser(contact) {
		const reload = this.getReloader(contact);
		this.modal
			.state('hub.loggedin.EmailContactsEdit', {
				params: { id: contact.id },
				heading:
					'Edit: ' +
					(
						`${contact.fname}` +
						(contact.fname_preferred ? ` (${contact.fname_preferred})` : '') +
						` ${contact.lname}` +
						(contact.lname_preferred ? ` (${contact.lname_preferred})` : '')
					).trim(),
				height: 250,
				width: 700,
			})
			.then(reload, reload);
	}

	removeUser(user) {
		this.Api.delete(`/distribution_lists/${this.id}/contacts/${user.id}`);
		this.newUsers = _.without(this.newUsers, user);
	}

	getReloader(contact) {
		return () => {
			this.Api.get(`/users/${contact.id}`).then(user => {
				contact.email = user.email;
				contact.fname = user.fname;
				contact.lname = user.lname;
				contact.fname_preferred = user.fname_preferred;
				contact.lname_preferred = user.lname_preferred;
			});
		};
	}

	focusFname() {
		this.modal.attemptFocus();
	}
}
